import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Col, Spinner } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { profileTeamDashboardRequest, profileDashboardRequest } from '../../../requests/dashboards';
import { camelCaseEmptyStringRecursive } from '../../../services/utils';
import { sendAlert } from '../../../actions/utils';
import { HRDashboardStyled, Icon } from '../..';

const PendingDocuments = ({ handleMoreInfoButton, tab, moreData, signature }) => {
  const dispatch = useDispatch();
  const [cards, setCards] = useState({});
  const [showSpinner, setShowSpinner] = useState(1);
  const pendingCard = tab === 'profile' ? cards.signature : cards?.totalRequestsCount;

  const handleFailureRequest = error => {
    setShowSpinner(0);
    const { response } = error;
    dispatch(sendAlert({ kind: 'error', message: response?.data?.message }));
  };

  const fetchCardData = () => {
    if (tab === 'profile') {
      profileDashboardRequest({
        dispatch,
        successCallback: response => {
          setCards(camelCaseEmptyStringRecursive(response.data));
          setShowSpinner(0);
        },
        failureCallback: error => handleFailureRequest(error)
      });
    } else {
      profileTeamDashboardRequest({
        dispatch,
        successCallback: response => {
          setCards(camelCaseEmptyStringRecursive(response.data).allRequestsCount);
          setShowSpinner(0);
        }
      });
    }
  };
  useEffect(fetchCardData, [moreData]);

  const history = useHistory();

  const handleCardClick = () => {
    history.push('/profile?tab=signature');
  };

  return (
    <>
      {showSpinner ? (
        <Col className="mt-5">
          <div className="containerSpinnerLoadDash mb-5">
            <Spinner animation="border" variant="primary" />
          </div>
        </Col>
      ) : (
        <>
          <HRDashboardStyled
            title={pendingCard}
            label="Doc. por Firmar"
            labelColor="#827f7f"
            TopHeaderColor="#fff"
            GeneralColor="#b40000"
            subtitle="Documento(s) por Aprobar/Firmar"
            TypeCard="OnlyInformation"
            onRequest={false}
            Downloadable={false}
            labelFontSize="12px"
            topHeight={50}
            ViewMore={tab !== 'team'}
            onClick={handleCardClick}
          />

          {tab === 'team' && (
            <button
              type="button"
              onClick={handleMoreInfoButton}
              style={{
                border: signature ? '1px solid #65b68f' : '1px solid #ccc',
                backgroundColor: signature ? '#65b68f' : '#ccc',
                position: 'absolute',
                right: 20,
                bottom: 10,
                cursor: signature ? 'pointer' : 'not-allowed'
              }}
              disabled={!signature}
            >
              <Icon icon="search" height="25px" width="16px" color="white" />
            </button>
          )}
        </>
      )}
    </>
  );
};

export default PendingDocuments;
